module.exports = __webpack_public_path__ + "img/1.37abb25e.jpg";